import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import ContentHeader from '../Layout/ContentHeader';
import Link from '../Helper/Link';
import PasswordField from '../Form/PasswordField';
import { Cover } from '../Helper/Cover';
import Select from '../Form/Select';
import TextField from '../Form/TextField';

const marketingSourceOptions = [
  { key: '', value: 'Select' },
  { key: 'Recommendation', value: 'Someone I know recommended you' },
  { key: 'Google', value: 'I found you on Google' },
  { key: 'Meta', value: 'I saw you on Facebook or Instagram' },
  { key: 'Event', value: 'I met you at an event/conference/webinar' },
  { key: 'Marketing content', value: 'I read about you in a blog or newsletter' },
  { key: 'Review page', value: 'I saw you on G2 / review page' },
  { key: 'Edu', value: 'I had a class that taught your products' },
  { key: 'Partner', value: 'I heard about you from a partner or reseller' },
  { key: 'Other', value: 'Other' },
];

const platforms = [
  { key: '', value: 'Select' },
  { key: 'Revit', value: 'Revit' },
  { key: 'SketchUp', value: 'SketchUp' },
  { key: 'Rhino', value: 'Rhino' },
  { key: '3ds Max', value: '3ds Max' },
  { key: 'Maya', value: 'Maya' },
  { key: 'Cinema 4D', value: 'Cinema 4D' },
  { key: 'Unreal', value: 'Unreal' },
  { key: 'Houdini', value: 'Houdini' },
  { key: 'Nuke', value: 'Nuke' },
  { key: 'Blender', value: 'Blender' },
  { key: 'ArchiCAD', value: 'ArchiCAD' },
  { key: 'Vectorworks', value: 'Vectorworks' },
  { key: 'Autocad', value: 'Autocad' },
  { key: 'Other', value: 'Other' },
];

const roles = [
  { key: '', value: 'Select' },
  { key: 'Administrator', value: 'Administrator' },
  { key: 'Architect', value: 'Architect' },
  { key: 'BIM Manager', value: 'BIM Manager' },
  { key: 'Business Owner', value: 'Business Owner' },
  { key: 'Construction Specialist', value: 'Construction Specialist' },
  { key: 'Interior Designer', value: 'Interior Designer' },
  { key: 'Designer - Product', value: 'Designer - Product' },
  { key: 'Director', value: 'Director' },
  { key: 'Educator', value: 'Educator' },
  { key: 'Engineer', value: 'Engineer' },
  { key: 'Project Manager', value: 'Project Manager' },
  { key: 'Student', value: 'Student' },
  { key: '3D Artist', value: '3D Artist' },
  { key: 'Technical Director', value: 'Technical Director' },
  { key: 'VFX Supervisor', value: 'VFX Supervisor' },
  { key: 'Unknown', value: 'Unknown' },
  { key: 'Other', value: 'Other' },
];

const form = (data, onInputChange, onSubmit, validateInput, t) => (
  <div className="wrapper-shrink">
    <h1 className="title">{t('Complete your account')}</h1>
    <form
      id="form-reset-password"
      action=""
      method="post"
      onSubmit={(e) => e.preventDefault() || (!data.loading && onSubmit())}
    >
      <h4>{t('Set up your password')}</h4>
      <br />
      <PasswordField
        inputName="newPassword"
        value={data.newPassword}
        showValidationRules
        label={<span>{t('Password')}</span>}
        valid={data.fieldsValidated?.newPassword}
        error={data.fieldErrors?.newPassword}
        onChange={(e) => {
          onInputChange(e.target.id, e.target.value);
          validateInput(e.target.id, e.target.value);
        }}
      />
      <h4>{t('Tell us more about yourself')}</h4>
      <br />
      <Select
        selectName="marketingSource"
        label={t('How did you hear about us?')}
        value={data.marketingSource}
        error={data.fieldErrors?.marketingSource}
        valid={data.fieldsValidated?.marketingSource}
        options={marketingSourceOptions}
        onChange={(e) => {
          e.preventDefault();
          onInputChange(e.target.id, e.target.value);
          validateInput(e.target.id, e.target.value);
        }}
        onInputChange={onInputChange}
        validateInput={validateInput}
      />
      {data.marketingSource === 'Other' && (
        <TextField
          inputName="marketingSourceOther"
          label={t('Other')}
          value={data.marketingSourceOther}
          error={data.fieldErrors?.marketingSourceOther}
          valid={data.fieldsValidated?.marketingSourceOther}
          onChange={(e) => e.preventDefault() || onInputChange(e.target.id, e.target.value)}
          onBlur={(e) => validateInput(e.target.id, e.target.value)}
        />
      )}
      <Select
        selectName="platformOfInterest"
        label={t('What platform will you primarily be using our product with?')}
        value={data.platformOfInterest}
        error={data.fieldErrors?.platformOfInterest}
        valid={data.fieldsValidated?.platformOfInterest}
        options={platforms}
        onChange={(e) => {
          e.preventDefault();
          onInputChange(e.target.id, e.target.value);
          validateInput(e.target.id, e.target.value);
        }}
        onInputChange={onInputChange}
        validateInput={validateInput}
      />
      {data.platformOfInterest === 'Other' && (
        <TextField
          inputName="platformOfInterestOther"
          label={t('Other')}
          value={data.platformOfInterestOther}
          error={data.fieldErrors?.platformOfInterestOther}
          valid={data.fieldsValidated?.platformOfInterestOther}
          onChange={(e) => e.preventDefault() || onInputChange(e.target.id, e.target.value)}
          onBlur={(e) => validateInput(e.target.id, e.target.value)}
        />
      )}
      <Select
        selectName="role"
        label={t('What best describes your role?')}
        value={data.role}
        error={data.fieldErrors?.role}
        valid={data.fieldsValidated?.role}
        options={roles}
        onChange={(e) => {
          e.preventDefault();
          onInputChange(e.target.id, e.target.value);
          validateInput(e.target.id, e.target.value);
        }}
        onInputChange={onInputChange}
        validateInput={validateInput}
      />
      {data.role === 'Other' && (
        <TextField
          inputName="roleOther"
          label={t('Other')}
          value={data.roleOther}
          error={data.fieldErrors?.roleOther}
          valid={data.fieldsValidated?.roleOther}
          onChange={(e) => e.preventDefault() || onInputChange(e.target.id, e.target.value)}
          onBlur={(e) => validateInput(e.target.id, e.target.value)}
        />
      )}
      <TextField
        inputName="phoneNumber"
        label={t('Prefer a call? Add your phone (optional)')}
        value={data.phoneNumber}
        error={data.fieldErrors?.phoneNumber}
        valid={data.fieldsValidated?.phoneNumber}
        onChange={(e) => e.preventDefault() || onInputChange(e.target.id, e.target.value)}
        onBlur={(e) => validateInput(e.target.id, e.target.value)}
      />
      <div className="form-field-wrapper button-wrapper">
        <button id="btn-reset-password" type="submit" className="button btn-active" disabled={data.loading}>
          {t('SET PASSWORD')}
        </button>
        {data.error && (
          <p className="error-message text-left">
            <span className="error">{t(data.error.message)}</span>
          </p>
        )}
      </div>
    </form>
  </div>
);

const error = (err, t) => (
  <div className="wrapper-shrink error">
    <h5>
      <span className="icon-minus" /> {t(err.message)} Ref. {err.guid}
    </h5>
    <div className="button-wrapper">
      <Link action="PASSWORD_RECOVER" className="button btn-active">
        {t('Request a new one')}
      </Link>
    </div>
  </div>
);

const PasswordSetup = withTranslation()(({ data, onInputChange, onSubmit, validateInput, t }) => (
  <>
    <Cover className="column image-cover" backgroundImage='url("/images/cover-secondary.png")' />
    <div className="wrapper profile password-setup">
      <ContentHeader />
      <div className="column content">
        {data.validating && <span>{t('LOADING...')}</span>}
        {data.validatingError && error(data.validatingError, t)}
        {data.codeValid && data.code && !data.validatingError && form(data, onInputChange, onSubmit, validateInput, t)}
      </div>
    </div>
  </>
));

export default connect(
  (state) => ({ data: state.profileSetupPassword }),
  (dispatch) => ({
    onInputChange: (id, value) =>
      dispatch({
        type: 'SETUP_PASSWORD_INPUT_CHANGE',
        data: { id, value },
      }),
    onSubmit: () => dispatch({ type: 'SUBMIT_SETUP_PASSWORD' }),
    validateInput: (id, value) => dispatch({ type: 'SETUP_PASSWORD_VALIDATE_INPUT', data: { id, value } }),
  }),
)(PasswordSetup);
